import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { downloadedFile } from "src/app/services/base/base.service";
import { ManutencaoCTEService } from "src/app/services/gestao-de-cte/gestao-de-cte.service";
import {
  preLoteDetails,
  sessaoCardGestaoPreLotes,
  tipoAcao,
} from "../gestao-de-cte.model";
import { ModalConfirmacaoLoteComponent } from "../components/modal-confirmacao-lote/modal-confirmacao-lote.component";
import { ModalPesoComponent } from "../components/modal-peso/modal-peso.component";
import { CTeHubService } from "src/app/services/signalR/cte-hub/cte-hub.service";
import { SelectionModel } from "@angular/cdk/collections";
import { ReplaySubject, Subject } from "rxjs";
import { ClienteOutput } from "src/app/@shared/models/cliente.model";
import { takeUntil } from "rxjs/operators";
import { ModalRecalculoComponent } from "../components/modal-recalculo/modal-recalculo.component";
import { ModalResumoLoteGeradoComponent } from "../components/modal-resumo-lote-gerado/modal-resumo-lote-gerado.component";
import { ProdutoOutput } from "src/app/@shared/models/produto.model";
import { ProdutoService } from "src/app/services/produto/produto.service";
import { ModalTabelaPrecoComponent } from "../components/modal-tabela-preco/modal-tabela-preco.component";
import { AuthService } from "src/app/services/auth/auth.service";
import { FileStorageService, fileStorageOutput } from "src/app/services/file-storage/file-storage.service";
import { ModalConfirmacaoComponent } from "src/app/@shared/components/modal-confirmacao/modal-confirmacao.component";
import { MatCheckboxChange } from "@angular/material/checkbox";


@Component({
  selector: "app-pre-lotes",
  templateUrl: "./pre-lotes.component.html",
  styleUrls: ["./pre-lotes.component.scss"],
})
export class PreLotesComponent implements OnInit, OnDestroy {
  @Input() id: string; //identificador do pré-lote
  @Input() featureId: string;
  public habilitarRecalculo: boolean = false;
  public habilitarEfetivacao: boolean = false;
  file: any;
  filtros: sessaoCardGestaoPreLotes[];
  preLoteDetails: preLoteDetails;

  validacaoStartSubscription: any;
  validacaoEndSubscription: any;

  recalculoStartSubscription: any;
  recalculoEndSubscription: any;

  public fileName: "";
  public fileType: "";
  someSelected = false;
  isLoading: boolean = false;
  isLoadingDownload: boolean = false;
  isLoadingFilters: boolean = false;
  isLoadingGrid: boolean = false;

  declaracaoId: string;

  identificador;
  bGeral: boolean = false;

  public ocultaBotoesDeclaracao: boolean = false;
  public fase: string;

  public grid: MatTableDataSource<any> = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  public displayedColumns: any[] = [];
  public headerColumns: any[] = [];

  paging = { index: 0, size: 5, length: 0 };
  isLoadingUpload: boolean = false;
  rowData: any;
  bSobrepor: boolean = false;

  isConfirmacao: boolean = false;

  private onDestroy = new Subject<void>();
  clientes: ClienteOutput[];
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<
    ClienteOutput[]
  >(1);
  public clienteMultiFilter: FormControl = new FormControl();

  produtos: ProdutoOutput[];
  public filteredProdutos: ReplaySubject<ProdutoOutput[]> = new ReplaySubject<ProdutoOutput[]>(1);
  public produtoMultiFilter: FormControl = new FormControl();

  
  get bloqueiaAcoes() {
    const bloqueia = (status) => this.preLoteDetails?.preLoteStatusId == status;
    return this.preLoteDetails?.bFinalizado || [4, 5].some(bloqueia);
  }
  

  get obterCompletos() {
    var completos = this.filtros
      ?.map((f) => f.cards)
      .flat()
      .filter((c) => c.id == 1)[0];
    return completos;
  }

  get obterSelecionados() {
    var selecionados = this.filtros
      ?.map((f) => f.cards)
      .flat()
      .filter((c) => c.id == 8)[0];
    return selecionados ?? this.obterCompletos;
  }

  get obterNaoSelecionados() {
    var naoSeleionados = this.filtros
      ?.map((f) => f.cards)
      .flat()
      .filter((c) => c.id == 3)[0];
    return naoSeleionados;
  }

  get obterReemissao() {
    var selecionados = this.filtros
      ?.map((f) => f.cards)
      .flat()
      .filter((c) => c.id == 6)[0];
    return selecionados;
  }

  get obterNaoReemissao() {
    var naoSeleionados = this.filtros
      ?.map((f) => f.cards)
      .flat()
      .filter((c) => c.id == 7)[0];
    return naoSeleionados;
  }

  public filter: FormGroup = new FormGroup({});

  public filterForm = new FormGroup({
    clienteId: new FormControl(""),
    produtoId: new FormControl(""),
    numeroCte: new FormControl(""),
    chaveCte: new FormControl(""),
    cepRecalculo: new FormControl(""),
    munRecalculo: new FormControl(""),
    uFDestinoRecalculo: new FormControl(""),
    qtdPedidos: new FormControl("")
  });
  get clienteId() {
    return this.filterForm.get("clienteId").value;
  }
  get produtoId() {
    return this.filterForm.get("produtoId").value;
  }
  get numeroCte() {
    return this.filterForm.get("numeroCte").value;
  }
  get chaveCte() {
    return this.filterForm.get("chaveCte").value;
  }
  get cepRecalculo() {
    return this.filterForm.get("cepRecalculo").value;
  }
  get munRecalculo() {
    return this.filterForm.get("munRecalculo").value;
  }
  get uFDestinoRecalculo() {
    return this.filterForm.get("uFDestinoRecalculo").value;
  }
  get qtdPedidos() {
    return this.filterForm.get("qtdPedidos").value;
  }

  constructor(
    public snackBar: MatSnackBar,
    public route: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    public dialog: MatDialog,
    public service: ManutencaoCTEService,
    public produtoService: ProdutoService,
    public fileService: FileStorageService,
    public cteHub: CTeHubService,
    private cdr: ChangeDetectorRef
  ) {
    const identificador = this.route.snapshot.paramMap.get("identificador");
    if (identificador) this.id = identificador;
    this.identificador = identificador;
  }

  ngOnInit() {
    this.listarClientes();
    this.loadPreLote();

    //conectar ao hub signalR
    this.cteHub.startConnection(() => {
      this.cteHub.conectar(this.identificador);

      this.validacaoStartSubscription =

        this.cteHub.prelotes_validacaoStart.subscribe((data) => {

          this.openSnackBar(
            `Iniciando validação do pré-lote.`,
            "OK",
            2000,
            "success-snackbar"
          );

          this.onStartValidation(data);
        });

      this.validacaoEndSubscription =

        this.cteHub.prelotes_validacaoEnd.subscribe((data) => {

          this.openSnackBar(
            `Validação concluída!`,
            "OK",
            2000,
            "success-snackbar"
          );


          this.onEndValidation(data);
        });

      this.recalculoStartSubscription =

        this.cteHub.prelotes_recalculoStart.subscribe((data) => {

          this.openSnackBar(
            `Iniciando recálculo do pré-lote.`,
            "OK",
            2000,
            "success-snackbar"
          );

          this.onStartValidation(data);
        });

      this.recalculoEndSubscription =

        this.cteHub.prelotes_recalculoEnd.subscribe((data) => {

          this.openSnackBar(
            `Recálculo concluído!`,
            "OK",
            2000,
            "success-snackbar"
          );


          this.onEndValidation(data);
        });
    });
    //this.toggleConfirmacao(true); //remover assim que resolver o Bug do grid vir com itemCompleto sempre false.
  }

  ngOnDestroy() {
    this.validacaoStartSubscription?.unsubscribe();
    this.validacaoEndSubscription?.unsubscribe();

    this.recalculoStartSubscription?.unsubscribe();
    this.recalculoEndSubscription?.unsubscribe();
  }

  clearFields() {
    this.paging.index = 0;
    this.filterForm.reset();
    this.loadFilters(this.isConfirmacao);
  }

  //Será disparada a cada atualização de eventos de processamento
  onStartValidation(prelote: preLoteDetails) {
    this.preLoteDetails = prelote;
    setTimeout(() => {
      this.loadFilters(this.isConfirmacao);
    }, 2000);
    //this.checkUpdates();
  }

  onEndValidation(prelote: preLoteDetails) {
    this.preLoteDetails = prelote;
    setTimeout(() => {
      this.loadPreLote();
    }, 2000);
    //this.checkUpdates();
  }

  toggleConfirmacao(p) {
    this.isConfirmacao = p;
    this.loadFilters(this.isConfirmacao);
  }

  // //Ação desconto
  // public async preLoteDesconto(identificacaoId = null) {
  //   const obj = {
  //     identificador: this.identificador,
  //     identificacaoId: identificacaoId,
  //     percentualDesconto: this.percentualDesconto,
  //   };
  //   this.service.preLoteDesconto(obj).subscribe(
  //     (response: any) => {
  //       // console.log(response);
  //     },
  //     (err: HttpErrorResponse) => {
  //       console.error(err);
  //       let errorMSg = err.error.message
  //         ? err.error.message
  //         : "Ocorreu um erro ao aplicar desconto! Tente novamente";
  //       this.openSnackBar(errorMSg, "OK", 3000, "warning-snackbar");
  //     }
  //   );
  // }

  // Ação Declaração
  uploadDeclaracao(sobrepor) {
    this.setSobrepor(sobrepor);
    let element: HTMLElement = document.querySelector(
      'input[id="fileUpload_geral"]'
    ) as HTMLElement;
    element.click();
  }

  private gerarArquivo(file: downloadedFile) {
    const url = window.URL.createObjectURL(file.blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public async salvarDocumentoGestao(fileContent, fileName, ext) {
    this.isLoading = true;
    // let ext = 'txt';
    let obj = {
      nomeArquivo: fileName,
      extensao: ext.split("/")[1],
      documentoBase64: fileContent.split(",")[1],
    };
    this.fileService
      .UploadFile(obj)
      .subscribe(
        (response: HttpResponse<fileStorageOutput>) => {
          if (response.status == 200) {
            this.openSnackBar(
              `Arquivo enviado com sucesso`,
              "OK",
              3000,
              "success-snackbar"
            );
            this.declaracaoId = response.body.identificador;
            this.atualizarDeclaracao(this.declaracaoId);
            //TODO: requisitar atualização com o guid do arquivo recebido
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            `Erro carregar arquivo, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoading = false));
  }

  public async atualizarDeclaracao(identificador) {
    let obj = {
      declaracaoId: identificador,
      identificador: this.identificador,
      identificacaoId: this.rowData?.id ? this.rowData?.id : null,
      bSobrepor: this.bSobrepor,
    };
    this.service
      .atualizarDeclaracao(obj)
      .subscribe(
        (response) => {
          this.loadFilters(this.isConfirmacao);
        },
        (err: HttpErrorResponse) => {
          console.error(err.error.message);
          this.isLoading = false;
          this.openSnackBar(
            `Ocorreu um erro, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoading = false));
  }

  public async DownloadDocumentoGestao(identificador) {
    this.isLoadingDownload = true;
    this.fileService
      .DownloadFile(
        identificador,
        (response) => this.gerarArquivo(response),
        (err) => console.log(err)
      )
      .add(() => (this.isLoadingDownload = false));
  }

  downloadDeclaracao(grid) {
    this.DownloadDocumentoGestao(grid.declaracaoId);
  }

  // Ação Recalculo
  modalRecalcular(sobrepor, identificacaoId = null) {
    //this.setSobrepor(sobrepor);
    const obj = {
      identificador: this.identificador,
      bSobrepor: sobrepor,
      identificacaoId: identificacaoId,
    };
    const dialogRef = this.dialog.open(ModalRecalculoComponent, {
      width: "900px",
      data: obj,
    });
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response === 1) {
        this.isLoading = true;
        await this.loadFilters(this.isConfirmacao);
        this.isLoading = false;
      }
      this.isLoading = false;
    });
  }

  // // Ação Reemissão
  // acaoReemissao(sobrepor, identificacaoId = null) {
  //   this.isLoading = true;
  //   this.setSobrepor(sobrepor);
  //   const obj = {
  //     identificador: this.identificador,
  //     bSobrepor: sobrepor,
  //     identificacaoId: identificacaoId,
  //   };
  //   this.service.preLoteReemissao(obj).subscribe(
  //     (response: any) => {
  //       // console.log(response);
  //     },
  //     (err: HttpErrorResponse) => {
  //       console.error(err);
  //       this.isLoading = false;
  //       this.openSnackBar(`Erro ao carregar.`, "OK", 5000, "danger-snackbar");
  //     }
  //   );
  // }

  

  public async loadPreLote() {
    this.isLoading = true;
    this.service.obterPreLoteDetails(this.id).subscribe(
      (response: preLoteDetails) => {
        if (response) {
          this.preLoteDetails = response;
          if (this.preLoteDetails?.preLoteStatusId != 4 &&
            this.preLoteDetails?.preLoteStatusId != 5) {
            this.isLoading = false;
          }
          const acao = tipoAcao[this.preLoteDetails.tipoAcaoId];
          this.authService.checkFeature(`gestao.cte.pre-lotes.complementar.liberacao-fretes.${acao.toLowerCase()}.efetivar-lotes`).subscribe(temPermissao => {
            if (temPermissao === true) this.habilitarEfetivacao = true; });

          this.authService.checkFeature(`gestao.cte.pre-lotes.complementar.liberacao-fretes.${acao.toLowerCase()}.recalcular-fretes`).subscribe(temPermissao => {
            if (temPermissao === true) this.habilitarRecalculo = true; });

          this.loadGridColumns();
          this.loadFilters(this.isConfirmacao);
          //this.checkUpdates();
        } else {
          this.openSnackBar(
            `Pré-lote inexistente.`,
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(
          `Erro ao carregar informações de filtros, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
          "OK",
          10000,
          "danger-snackbar"
        );
      }
    );
  }

  // intervalUpdates;
  // checkUpdates() {
  //   if (this.intervalUpdates == null
  //     && this.preLoteDetails?.preLoteStatusId == 4) {
  //     this.intervalUpdates = setInterval(() => {
  //       if (!this.isLoadingFilters) {
  //         this.loadPreLote();
  //       }
  //     }, 15000);
  //   } else if (this.intervalUpdates && this.preLoteDetails?.preLoteStatusId != 4) {
  //     clearInterval(this.intervalUpdates);
  //     this.intervalUpdates = null;
  //     //buscar status atualizado do pré-lote
  //     this.loadPreLote();
  //   }
  // }

  loadGridColumns() {

    if (this.displayedColumns.length == 0) {

      this.cdr.detectChanges();
      this.headerColumns = ["headers-operacao", "headers-dados-ctes-01", "headers-dados-ctes-02", "headers-dados-ctes-03"];

      // //this.displayedColumns.push("origem");
      // this.displayedColumns.push("declaracaoNome");
      // this.displayedColumns.push("statusBloqueio");


      this.displayedColumns = [
        "checkbox",
        "action",
        "declaracaoNome",
        "statusBloqueio",
        "cliente",
        "produto",
        "chaveCTE",
        "qtdeNRT",
        "recalculoFrete_CEPRecalculo",
        "recalculoFrete_MunRecalculo",
        "recalculoFrete_UFRecalculo",
        "nrCTE",

        //"qtdeNF",
        "filial",
        "dtEmissao",
        "tomador",
        "tipoProcessamento",
        "tipoCte",
        "statusDescricao",
        "statusCancelamento",
        //
        "pid",
        "peso",
        "cepDestino",
        "valorFrete",
        "imposto",
        "adValorem",
        "gris",
        "totalFrete"
      ];

      if (this.preLoteDetails?.permiteRecalculo) {
        let columns = [
          "recalculoFrete_FreteTotal",
          "recalculoFrete_DiferencaFreteTotal",
          "recalculoFrete_FretePeso",
          "recalculoFrete_AliqICMS",
          "recalculoFrete_ValorICMS",
          "recalculoFrete_ValorADVALOREM",
          "recalculoFrete_ValorGris",
          "recalculoFrete_PID",
          "recalculoFrete_IdTabelaPreco",
          "recalculoFrete_PesoRecalculo",
          "recalculoFrete_TipoPesoUtilizado",
        ];
        columns.map((columns) => {
          this.displayedColumns.push(columns);
        });

        this.headerColumns.push("headers-recalculo");
      }

      if (this.preLoteDetails?.controlaReemissao) {
        this.headerColumns.push("header-reemissao");
        this.displayedColumns.push("reemissao");
      }
    }
  }

  validarPreLote() {
    this.isLoading = true;
    this.service
      .validarPreLote(this.id)
      .subscribe(
        (response: HttpResponse<preLoteDetails>) => {
          if (response.status === 200) {
            this.preLoteDetails = response.body;
            this.preLoteDetails.preLoteStatusId = 4; //forçar status Em Validação
            this.preLoteDetails.descricaoStatus = "Validação em Processamento"; //forçar status Em Validação
            //this.loadFilters(this.isConfirmacao);
          } else {
            this.openSnackBar(
              `Pré-lote inexistente.`,
              "OK",
              5000,
              "danger-snackbar"
            );
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            `Erro ao carregar informações de filtros, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async loadGrid() {
    this.isLoading = true;

    let _filtros = this.filtros
      //quando confirmação, somente os completos
      .filter(filtro => !this.isConfirmacao || filtro.sessaoId == 3)
      .map((filtro) => filtro
        .cards
        .filter((t) => t.selecionado === true)
        .map((t) => t.id)).flat();

    const obj = {
      //quando confirmação e nenhum filtro, enviar 1 (completos)
      filtros: this.isConfirmacao && _filtros.length == 0 ? [1] : _filtros,
      numeroCTE: this.numeroCte,
      chaveCTE: this.chaveCte,
      cEP: this.cepRecalculo,
      municipio: this.munRecalculo,
      uFDestino: this.uFDestinoRecalculo,
      clienteId: this.clienteId,
      qtdPedidos: this.qtdPedidos,
      produtoId: this.clienteId ? this.produtoId : null,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
    };

    this.service
      .filtrarGridAcao(this.id, obj)
      .subscribe(
        (response: any[]) => {
          this.isLoading = false

          this.paging.length = response.length ? response[0].totalCount : 0;
          this.grid.data = response;
          this.cdr.detectChanges();
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false
          console.error(err);
          this.openSnackBar(
            `Erro ao carregar itens do pré-lote, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      );
  }

  selectAll(selected: MatCheckboxChange) {
    this.checkboxClick(selected);
  }

  public checkboxClick(event, row = null) {
    this.isLoading = true;
    this.selecionarItensGridAcao(event, row);
  }

  async selecionarItensGridAcao(event, row = null) {
    this.isLoading = true;

    let obj = {
      identificacaoId: row?.id,
      identificador: this.identificador,
      selecionado: event.checked,
    };
    await this.service
      .selecionarItensGridAcao(obj)
      .subscribe(
        (response) => {
          if (response.status === 200) {
            this.loadFilters(this.isConfirmacao);
          } else {
            return this.openSnackBar(
              `Não foi possível selecionar a NRT.`,
              "OK",
              5000,
              "danger-snackbar"
            );
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            `Erro ao selecionar itens, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoading = false));
  }

  public toggleClick(event, row = null) {

    this.selecionarItensReemisao(event, row);

    //   if (event.checked == true) {
    //     const retorno = this.dialog.open(ModalConfirmacaoComponent, {
    //       width: "540px",
    //       data: {
    //         textoCancelar: "Não",
    //         textoOk: "Sim",
    //         texto:
    //           row == null
    //             ? "Tem certeza que deseja reemitir todas as NRTs?"
    //             : "Tem certeza que deseja reemitir esta NRT?",
    //       },
    //     });
    //     retorno.afterClosed().subscribe(async (response) => {
    //       if (response == 1) {
    //         this.selecionarItensReemisao(event, row);
    //         //this.loadFilters(this.isConfirmacao);
    //       } else {
    //         return;
    //       }
    //     });
    //   } else {
    //     this.selecionarItensReemisao(event, row);
    //     //this.loadFilters(this.isConfirmacao);
    //   }
  }

  public selecionarItensReemisao(event, row) {
    let obj = {
      identificacaoId: row?.id,
      identificador: this.identificador,
      selecionado: event.checked,
    };
    this.service
      .selecionarItensReemisao(obj)
      .subscribe(
        (response) => {
          if (response.status == 200) {
            this.loadFilters(this.isConfirmacao);
          } else {
            this.openSnackBar(
              `Erro ao selecionar Item.`,
              "OK",
              5000,
              "danger-snackbar"
            );
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            `Erro ao selecionar itens, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoading = false));
  }

  setRowData(grid) {
    this.rowData = grid;
  }

  setSobrepor(p: boolean) {
    this.bSobrepor = p;
  }

  public refreshFilter(event, card) {
    //sincronizar demais cards que possuam o mesmo ID
    this.filtros.forEach(f => f.cards.filter(c => c.id === card.id).forEach(card2 => card2.selecionado = event.checked));

    this.paging.index = 0;
    this.loadGrid();
  }

  public async loadFilters(confirmacao) {
    this.isLoadingFilters = true;
    const obj = {
      identificador: this.id,
      confirmacao: confirmacao,
    };
    this.service
      .obterPreLoteCards(obj)
      .subscribe(
        (response: any[]) => {
          this.updateFilters(response);
          this.loadGrid();
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(
            `Erro ao carregar informações de filtros, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoadingFilters = false));
  }

  updateFilters(tipoParams) {
    let selecionados = this.filtros?.map(f => f.cards.filter(c => c.selecionado == true).map(c => c.id)).flat() || [];

    //manter seleção
    if (selecionados.length > 0)
      tipoParams.forEach((element) => {
        element.cards.forEach((card) => {
          card.selecionado = selecionados.some((id) => card.id == id);
        });
      });

    this.filtros = tipoParams;
  }

  onFileChange(ev): void {
    this.file = ev.target.files;
    this.fileName = this.file[0].name;
  }

  loadFile(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file.target.files[0]);
    reader.onloadend = () => {
      this.file = reader.result;
    };
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: "540px",
      data: {
        titulo: "Envio de Declaração",
        texto: `Desejar enviar o arquivo: ${file.target.files[0].name}?`,
      },
    });
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response === 1) {
        this.fileName = file.target.files[0].name;
        this.fileType = file.target.files[0].type;
        this.salvarDocumentoGestao(this.file, this.fileName, this.fileType);
        this.file = null;
      } else {
        this.fileName = "";
        this.file = "";
      }
    });
  }

  onPageChange(evt: { pageIndex: number; pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.loadGrid();
  }

  visualizarPeso(grid) {
    const dialogRef = this.dialog.open(ModalPesoComponent, {
      width: "1200px",
      data: { dados: grid, isModal: true },
    });
    dialogRef.afterClosed();
  }

  visualizarTabelaPreco(idTabelaPreco, cepOrigem, cepDestino) {
    const dialogRef = this.dialog.open(ModalTabelaPrecoComponent, {
      width: "auto",
      data: { 
        idTabela: idTabelaPreco,
        cepOrigem: cepOrigem,
        cepDestino: cepDestino,  
        isModal: true,

       },
    });
    dialogRef.afterClosed();
  }

  modalConfirmacaoLote() {
    const dialogRef = this.dialog.open(ModalConfirmacaoLoteComponent, {
      width: "1200px",
      data: this.identificador,
    });
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response?.identificador) {
        this.gerarLotes(response);
      }
    });

  }

  gerarLotes(input) {
    this.isLoading = true;
    this.service.gerarLotes(input).subscribe(
      (response: any) => {
        if (response) {
          this.loadPreLote();
          this.resumoLoteGerado(response.body);
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(`Erro ao gerar lotes, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  resumoLoteGerado(lotesGerados) {
    const dialogRef = this.dialog.open(ModalResumoLoteGeradoComponent, {
      width: '800px',
      data: {
        texto: `Resumo de lotes gerados`,
        gridLote: lotesGerados
      },
    });
    dialogRef.afterClosed().subscribe(
      async response => {
        this.router.navigate(['/cadastro/cte/gestao/lotes-processamento'], { queryParams: { load: 'true' } });
      });
  }


  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  public async listarClientes() {
    return this.service
      .preLoteClientes(this.identificador)
      .toPromise()
      .then(
        (response: ClienteOutput[]) => {
          this.clientes = response
            .filter((x) => x.nome != "")
            .sort((a, b) => (a.nome < b.nome ? -1 : 1));
          this.filteredClientes.next(this.clientes.slice());
          this.clienteMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.clientes,
                this.clienteMultiFilter,
                this.filteredClientes,
                "nome"
              );
            });
        },
        (err: HttpErrorResponse) => {
          this.openSnackBar(
            "Erro ao carregar clientes, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async listarProdutos() {
    this.filterForm.get("produtoId").setValue("")
    this.produtos = [];
    return this.produtoService.selecionarProdutos(this.clienteId).toPromise().then((response: ProdutoOutput[]) => {
      this.produtos = response.filter(x => x.descricao != '').sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
      this.filteredProdutos.next(this.produtos.slice());
      this.produtoMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.produtos, this.produtoMultiFilter, this.filteredProdutos, 'descricao');
        });
      if (!this.produtos.length) {
        this.openSnackBar('Este cliente não possui produtos cadastrados!', 'OK', 5000, 'warning-snackbar');
        this.filterForm.get('produtoSelecionado').disable();
      }
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar produtos, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivoExportar(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data)
    const blob = new Blob([arrBuffer], {
      type
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcel() {
    this.isLoadingDownload = true;
    const obj = {
      identificador: this.identificador,
      filtros: this.isConfirmacao
        ? [1]
        : this.filtros
          .map((filtro) =>
            filtro.cards
              .filter((t) => t.selecionado === true)
              .map((t) => t.id)
          )
          .flat(),
      numeroCTE: this.numeroCte,
      chaveCTE: this.chaveCte,
      clienteID: this.clienteId,
      produtoId: this.produtoId,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
    };
    this.service.exportarGridPreLotes(this.identificador, obj).subscribe(
      (response: any) => {
        this.gerarArquivoExportar(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        )
      },
      (err: HttpErrorResponse) => console.error('erro', err),
      () => this.isLoadingDownload = false
    )
  }

  private filtroGeral(
    filtro: any,
    multifilter: any,
    filtered: any,
    field: string
  ) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(
        (response) => response[field].toLowerCase().indexOf(search) > -1
      )
    );
  }



}
